import React, { useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

interface IProps {
  bottomRef: React.MutableRefObject<HTMLElement>;
}

const HeroSection = ({ bottomRef }: IProps) => {
  const { t: tHero } = useTranslation('', { keyPrefix: '$pages.$home.$heroSection' });
  const { t: tCategory } = useTranslation('', { keyPrefix: '$local.$category' });
  const { t: tLinks } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$hero' });

  useEffect(() => {
    const container = document.querySelector('.home');
    const ctx = gsap.context(() => {
      gsap.registerPlugin(ScrollTrigger);
      ScrollTrigger.create({
        trigger: '.hp-nav',
        start: 'top =+42',
        end: 'top bottom',
        onEnter: () => {
          container.classList.add('show-top-nav');
        },
        onEnterBack: () => {
          container.classList.remove('show-top-nav');
        },
      });
    });
    return () => ctx.revert();
  }, []);
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    // use ref
    const element = bottomRef.current;
    window.scrollTo({
      top: element.offsetTop,
      behavior: 'smooth',
    });
  };
  return (
    <section className="diamond-wrap">
      <div className="content-wrap">
        <div className="nav-wrap">
          {/* Logo only; the page h1 is the sr-only one in Home.tsx */}
          <div className="hero-logo" aria-hidden="true">
            {tHero('title')}
          </div>
          <div>
            <ul className="hp-nav">
              <li>
                <a href={tLinks('fragrance')} className="base-link">
                  {tCategory('fragrance')}
                </a>
              </li>
              <li>
                <a href={tLinks('bath')} className="base-link">
                  {tCategory('bath')}
                </a>
              </li>
              <li>
                <a href={tLinks('lifestyle')} className="base-link">
                  {tCategory('lifestyle')}
                </a>
              </li>
              <li>
                <a href={tLinks('artistSeries')} className="base-link">
                  {tCategory('artistSeries')}
                </a>
              </li>
              <li>
                <a href={tLinks('limitedEdition')} className="base-link">
                  {tCategory('limitedEdition')}
                </a>
              </li>
              <li>
                <a href={tLinks('sleep')} className="base-link">
                  {tCategory('sleep')}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="scroll">
          <a href="#bottom" className="btn-white" onClick={handleClick}>
            <span>{tHero('explore')}</span>
          </a>
        </div>
      </div>
      <div className="video">
        <video autoPlay loop muted playsInline>
          <source src="/videos/edition-diamond-video.webm" type="video/webm" />
          <source src="/videos/edition-diamond-video.mp4" type="video/mp4" />
          <source src="/videos/edition-diamond-video.ogv" type="video/ogg" />
        </video>
      </div>
    </section>
  );
};

export default HeroSection;
